export default __webpack_public_path__ + "static/media/93Holo.f5a77f90.gif";